import { NextPage } from 'next';
import React from 'react';
import RegisterLayout from '../components/layout/register/RegisterLayout';
import AnalyticsPageView from '../components/AnalyticsPageView';
import RegisterPage from '../containers/RegisterPage';
import { REGISTER_LINK } from '../constants/home';

const Register: NextPage = () => (
  <RegisterLayout>
    <AnalyticsPageView url={REGISTER_LINK} mobileOnly>
      <RegisterPage />
    </AnalyticsPageView>
  </RegisterLayout>
);

export default Register;
